import * as React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';

import { FilterBase, mapStateToProps, IExternalProps, FiltersProps } from './filter-base';
import { Dispatch } from 'redux';
import { upsertFilter, removeFilter } from '../redux-state/actions/filters';
import Awesomplete = require('awesomplete');
import { string } from 'prop-types';
import { RefObject } from 'react';
import { IOption } from '../classes/input-option';
import { IAppState } from '../classes/app';

interface FilterTextboxProps extends FiltersProps {
    clickToSubmit: boolean;
    showMoreLink: boolean;
    placeHolder?: string;
    searchByLocation?: boolean;
    searchByLocationPlaceHolder?: string;
}

interface DispatchToProps {
    updateFilter: (query: string) => void;
    updateSecondaryFilter: (property: string, query: string) => void;
}

interface StateToProps {
    options?: IOption[];
    selectedOptions?: string;
    matching?: { [id: number]: number }
    loading?: boolean;
    IsDisabled?: boolean;
    addressOrCityOrZipValue?: string;
}

export class FilterTextbox extends FilterBase<FilterTextboxProps> {

    private _autocomplete: Awesomplete;

    private _locationError: boolean = false;

    private _inputAddressOrCityOrZipRef: RefObject<any>;

    private _inputValueRef: RefObject<any>;

    get componentProps(): StateToProps {
        return this.props;
    }

    componentDidMount() {
        let inputBox = this._inputValueRef.current as HTMLInputElement;
        this._autocomplete = new Awesomplete(inputBox, {
            minChars: 3,
            maxItems: 15,
            list: []
        });

        let inputButton = document.getElementById(this.props.property + "Button") as HTMLButtonElement;
        inputBox.addEventListener('awesomplete-selectcomplete', function (e) {
            console.log("selected")
            inputButton.click();
        })
    }
    constructor(props) {
        super(props)
        this._inputAddressOrCityOrZipRef = React.createRef();
        this._inputValueRef = React.createRef();
    }

    private updateSearchValue(e) {
        e.preventDefault();

        let inputBox = this._inputValueRef.current as HTMLInputElement;
        this.props.updateFilter(inputBox.value);

        if (this.props.searchByLocation) {
            const addressOrCityOrZipBox = this._inputAddressOrCityOrZipRef.current as HTMLInputElement;
            this.props.updateSecondaryFilter('AddressOrCityOrZip', addressOrCityOrZipBox.value);
        }
    }

    private handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.updateSearchValue(e);
        }
    }

    private handleKeyPressOnInput(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            let inputBox = this._inputValueRef.current as HTMLInputElement;
            this.props.updateFilter(inputBox.value);
        }
    }

    private getFullSearchURL() {
        return window["fullSearchURL"] as any;
    }

    private onChange(e) {
        let inputBox = this._inputValueRef.current as HTMLInputElement;
        let moreLink = document.getElementById("more") as HTMLAnchorElement;
        if (inputBox.value.length > 2) {
            axios.get("/api/searchresult/getautocomplete?query=" + inputBox.value).then(res => {
                if (res.data.terms) {
                    this._autocomplete.list = res.data.terms
                }
            })
        }
        if (moreLink == null)
            return;

        moreLink.href = this.getFullSearchURL() + "?q=" + inputBox.value;
    }

    private useMyLocationClick(e) {
        this._locationError = false;
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                this.currentLocationHandler.bind(this),
                this.currentLocationErrorHandler.bind(this));
        }
        else {
            this._locationError = true;
        }
    }

    private async currentLocationHandler(positionResult) {
        console.log(`Lat: ${positionResult.coords.latitude}, Lng:${positionResult.coords.longitude}`);

        try {
            const serverResult = await axios.get(`/api/searchresult/GetAddressReverseGeocode?latitude=${positionResult.coords.latitude}&longitude=${positionResult.coords.longitude}`);

            if (serverResult && serverResult.status == 200 && serverResult.data && serverResult.data.foundAddress) {
                const foundAddress = serverResult.data.foundAddress;
                console.log(`found Address: ${foundAddress}`);

                const addressOrCityOrZipBox = this._inputAddressOrCityOrZipRef.current as HTMLInputElement;
                addressOrCityOrZipBox.value = foundAddress;
                this.props.updateSecondaryFilter('AddressOrCityOrZip', foundAddress);
            }
            else {
                this._locationError = true;
            }
        } catch (e) {
            this._locationError = true;
            console.error(e);
        }
    }

    private currentLocationErrorHandler(error) {
        switch (error.code) {
            case error.PERMISSION_DENIED:
                console.error('User denied the request for Geolocation.');
                this._locationError = true;
                break;
            case error.POSITION_UNAVAILABLE:
                console.error('Location information is unavailable.');
                this._locationError = true;
                break;
            case error.TIMEOUT:
                console.error('The request to get user location timed out.');
                this._locationError = true;
                break;
            case error.UNKNOWN_ERROR:
                console.error('An unknown error occurred.');
                this._locationError = true;
                break;
        }

        this.props.updateSecondaryFilter('AddressOrCityOrZip', null);
    }

    private boundUpdateSearchValue = this.updateSearchValue.bind(this);
    private boundOnChange = this.onChange.bind(this);
    private boundHandleKeyPress = this.handleKeyPress.bind(this);
    private boundHandleKeyPressOnInput = this.handleKeyPressOnInput.bind(this);

    private boundSearchByLocationHandleKeyPress = this.handleKeyPress.bind(this);

    private boundSearchByLocationUseMyLocationClick = this.useMyLocationClick.bind(this);

    componentWillReceiveProps(nextProps: StateToProps) {

        if (this.componentProps.addressOrCityOrZipValue != nextProps.addressOrCityOrZipValue &&
            this._inputAddressOrCityOrZipRef && this._inputAddressOrCityOrZipRef.current) {

            const addressOrCityOrZipBox = this._inputAddressOrCityOrZipRef.current as HTMLInputElement;
            addressOrCityOrZipBox.value = nextProps.addressOrCityOrZipValue ? decodeURIComponent(nextProps.addressOrCityOrZipValue) : '';
        }

        if (this.componentProps.selectedOptions != nextProps.selectedOptions &&
            this._inputValueRef && this._inputValueRef.current) {

            const inputBox = this._inputValueRef.current as HTMLInputElement;
            inputBox.value = nextProps.selectedOptions ? decodeURIComponent(nextProps.selectedOptions) : '';
        }
    }

    renderFormElement() {

        var searchMoreURL = this.getFullSearchURL();
        const searchByLocationPlaceHolder = window["searchByLocationPlaceHolder"];

        return (
            <div className="adage-form-field-wrapper">
                {
                    this.props.title ? <label htmlFor={this.props.property}>{this.props.title}</label> : null
                }
                {
                    this.props.clickToSubmit ?
                        <form className={`adage-search-input-form ${this.props.searchByLocation && 'adage-search-by-location'}`} onSubmit={this.boundUpdateSearchValue}>
                            {this.props.searchByLocation ?
                                <>
                                    <div className="adage-search-by-location-input-wrapper adage-search-by-location-first-input">
                                        <label htmlFor={this.props.property}>
                                            <svg className="svg-icon" aria-hidden="true" focusable="false">
                                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-search" />
                                            </svg>
                                            Find
                                        </label>
                                        <input ref={this._inputValueRef} id={this.props.property} type="search" placeholder={this.props.placeHolder ? this.props.placeHolder : "Condition, Specialty, Name"} defaultValue={this.props.defaultTextBoxValue ? this.props.defaultTextBoxValue : ''} onKeyPress={this.boundHandleKeyPress} onChange={this.boundOnChange} />
                                    </div>
                                    <div className="adage-search-by-location-input-wrapper adage-search-by-location-second-input">
                                        <label htmlFor={this.props.property + "AddressOrCityOrZip"}>
                                            <svg className="svg-icon" aria-hidden="true" focusable="false">
                                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-location" />
                                            </svg>
                                            Near
                                        </label>
                                        <input id={this.props.property + "AddressOrCityOrZip"} ref={this._inputAddressOrCityOrZipRef} type="search" placeholder={searchByLocationPlaceHolder ? searchByLocationPlaceHolder : "City, State, Zip"} onKeyPress={this.boundSearchByLocationHandleKeyPress} />

                                        <button id={this.props.property + "UseLocation"} className="btnUseLocation" type="button" onClick={this.boundSearchByLocationUseMyLocationClick}>
                                            <svg className="svg-icon" aria-hidden="true" focusable="false">
                                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-use-my-location" />
                                            </svg>
                                            Use My Location
                                        </button>
                                    </div>
                                </>
                                :
                                <input ref={this._inputValueRef} id={this.props.property} type="search" placeholder={this.props.placeHolder ? this.props.placeHolder : "Name or Keyword"} defaultValue={this.props.defaultTextBoxValue ? this.props.defaultTextBoxValue : ''} onKeyPress={this.boundHandleKeyPress} onChange={this.boundOnChange} />
                            }
                            <button id={this.props.property + "Button"} className="btn" type="submit">{this.props.searchByLocation ? "Search Providers" : "Search"}</button>
                        </form>
                        :
                        <input ref={this._inputValueRef} id={this.props.property} type="search" placeholder={this.props.placeHolder ? this.props.placeHolder : "Name or Keyword"} onBlur={this.boundUpdateSearchValue} onKeyPress={this.boundHandleKeyPressOnInput} defaultValue={this.props.defaultTextBoxValue ? this.props.defaultTextBoxValue : ''} />
                }
                {
                    this._locationError ?
                        <>
                            <div className="adage-form-row error-message">There were issues retrieving your location!</div>
                        </>
                        : null
                }
                {
                    this.props.showMoreLink && searchMoreURL != undefined ?
                        <div>
                            <div className="adage-form-row">Looking for something else?</div>
                            <div><a className="bold" href={searchMoreURL + "?q=" + this.props.defaultTextBoxValue} id="more">Search the full site</a></div>
                        </div>
                        : null
                }
            </div>
        )
    }
}


export function textBoxMapDispatchToProps(dispatch: Dispatch, ownProps: IExternalProps): DispatchToProps {
    return {
        updateFilter: (query: string) => {
            if (!query || query === "") {
                dispatch(removeFilter(ownProps.property));
            } else {
                dispatch(upsertFilter(ownProps.property, encodeURIComponent(query)) as any)
            }
        },
        updateSecondaryFilter: (property: string, query: string) => {
            if (!query || query === "") {
                dispatch(removeFilter(property));
            } else {
                dispatch(upsertFilter(property, encodeURIComponent(query)) as any)
            }
        }
    }
}

export function textBoxMapStateToProps(state: IAppState, ownProps: IExternalProps): StateToProps {
    const options = state.filtersState.filterOptions[ownProps.property];

    const addressOrCityOrZipValue = state.filtersState.filters['AddressOrCityOrZip'];

    if (ownProps.property === "hospital" || ownProps.property === "practice") {
        return {
            IsDisabled: false,
            options: options ? Object.keys(options).map(function (key) { return { text: options[key], value: key } }).sort((a, b) => (a.text > b.text) ? 1 : -1) : [],
            selectedOptions: state.filtersState.filters[ownProps.property] ? state.filtersState.filters[ownProps.property] : "",
            addressOrCityOrZipValue: addressOrCityOrZipValue
        }
    }
    else {
        return {
            IsDisabled: false,
            options: options ? options.map(option => { return { text: option, value: option } }) : [],
            selectedOptions: state.filtersState.filters[ownProps.property] ? state.filtersState.filters[ownProps.property] : "",
            addressOrCityOrZipValue: addressOrCityOrZipValue
        }
    }

}

export const ConnectedFilterTextbox = connect(textBoxMapStateToProps, textBoxMapDispatchToProps)(FilterTextbox);